import { frontendURL } from '../../../../helper/URLHelper';

const BrandSettings = () => import('./BrandSettings.vue');

export default {
    routes: [
        {
            path: frontendURL('accounts/:accountId/settings/brand'),
            name: 'brand_settings',
            meta: {
                permissions: ['administrator'],
            },
            component: BrandSettings,
        },
    ],
};
